export default __webpack_public_path__ + "static/media/brush.0d854cb6.png";